/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

// --------------------
// INTERFACES
// --------------------
export interface YearSummaryData {
  year: string;
  onTime: number;
  late: number;
  wfh: number;
  absent: number;
  sickLeave: number;
}

export interface YearSummaryApiResponse {
  success: boolean;
  data: YearSummaryData;
}

// --------------------
// API FUNCTION
// --------------------
const getAttendanceYearSummary = async (
  year: string
): Promise<YearSummaryApiResponse> => {
  const queryParams = new URLSearchParams();
  queryParams.append("year", year);

  const { data } = await customAxios.get<YearSummaryApiResponse>(
    `/attendance/summary/year?${queryParams.toString()}`
  );

  return data;
};

// --------------------
// REACT QUERY HOOK
// --------------------
export const useGetAttendanceYearSummary = (year: string) =>
  useQuery<YearSummaryApiResponse, AxiosError>(
    ["attendance-year-summary", year],
    () => getAttendanceYearSummary(year),
    {
      enabled: !!year,
      onError: (error) =>
        showNotification({
          title: "Error Loading Year Summary",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load yearly summary",
          color: "red",
        }),
      refetchOnMount: "always",
      retry: 1,
      staleTime: 0,
    }
  );